import { useCallback, useGlobalState, useGlobalStateModifier, useHistory, } from "@discovery/common-dplus/lib/hooks";
import { _Config, _IsUserPremiumFromPartners, } from "@discovery/common-dplus/lib/state";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { Lens } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { useUser } from "../../../utils/hooks/useUser";
import { DplusLogo } from "../../atoms/DplusLogo";
import { Link } from "../../atoms/link";
import { HamburgerIcon } from "../../molecules/hamburger-icon";
import { DesktopSearch } from "../search-results/desktop-search";
import * as styles from "../nav-bar/styles.css";
import { memo } from "react";
import { HeaderVariants, Tags, Typography, } from "../../../components/atoms/typography";
import { pushModuleBuyNowLinkTracking } from "@discovery/common-dplus/lib/adobe";
import { blueshiftClickEvent } from "@discovery/common-dplus/lib/blueshift";
export const HomeRoute = Lens.prop("homeRoute");
export const Navbar = memo(({ hamburgerFooterList, loginUrl, read, allAccessToggle, isAllAccess, onClickM, userM, }) => {
    const [configM] = useGlobalState(_Config);
    const userDetailsM = M.map((user) => ({
        geoLocationM: user.attributes.currentLocationTerritory,
    }), userM);
    const geoLocation = M.fromMaybe(M.map((user) => user.geoLocationM, userDetailsM), "");
    const [isPremiumUserFromPartner] = useGlobalState(_IsUserPremiumFromPartners);
    const { isPremiumUser, isAnonymous, userId } = useUser();
    const isUserPremium = isPremiumUser || isPremiumUserFromPartner;
    const subscriptionCTA = M.chain((x) => x.subscriptionCTA, configM);
    const subscriptionCTALabelM = M.chain((x) => x.label, subscriptionCTA);
    const subscriptionCTALabel = M.fromMaybe(subscriptionCTALabelM, "");
    const subscriptionCTAUrlM = M.chain((x) => x.url, subscriptionCTA);
    const subscriptionCTAUrl = M.fromMaybe(subscriptionCTAUrlM, "");
    const handleClick = useCallback(() => {
        return config.standardPageRouteFragments.home;
    }, []);
    const onLogoClick = useGlobalStateModifier(handleClick, HomeRoute);
    const renderBuyNow = () => {
        const sendAnalyticsEvent = () => {
            pushModuleBuyNowLinkTracking("home", 0, "toolbar", subscriptionCTALabel, subscriptionCTAUrl);
        };
        const actionItems = () => {
            blueshiftClickEvent("home", "toolbar", 0, subscriptionCTALabel, subscriptionCTAUrl, userId);
            sendAnalyticsEvent();
        };
        return (React.createElement("div", { className: styles.mobilesignInContainer, onClick: () => actionItems(), id: "#buyNow" },
            React.createElement(Link, { href: subscriptionCTAUrl },
                React.createElement(Typography, { classNameM: M.of(styles.signIn), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, subscriptionCTALabel)))));
    };
    const renderNavbar = (showHeader) => {
        return (React.createElement("div", { className: showHeader ? styles.showHeader : styles.hideHeader },
            React.createElement(React.Fragment, null,
                React.createElement("div", { id: "#navbarMain", className: styles.navbar },
                    React.createElement("div", { className: geoLocation === "in"
                            ? styles.navWrapper
                            : styles.geoRestrictionHideMenubar, id: "#navbar" },
                        React.createElement("div", { className: styles.iconsContainer },
                            React.createElement(HamburgerIcon, { onClickM: M.of(onClickM), hamburgerFooterList: hamburgerFooterList, loginUrl: loginUrl, anonymous: isAnonymous, allAccessHandler: (id) => allAccessToggle(id), isAllAccess: isAllAccess }),
                            React.createElement(Link, { href: config.standardPageRouteFragments.home },
                                React.createElement("div", { id: "#dplusLogo", onClick: () => onLogoClick() }, isUserPremium ? (React.createElement(DplusLogo, { className: styles.logoPremium, isPremium: true, alt: "logo" })) : (React.createElement(DplusLogo, { className: styles.logo, alt: "logo", isPremium: false })))),
                            !isUserPremium && (path === "/" || path === "/home") && (React.createElement("div", null, renderBuyNow()))),
                        React.createElement(DesktopSearch, { read: read, loginUrl: loginUrl }))))));
    };
    const [changes] = useHistory();
    const path = changes.location.pathname;
    //TODO - need to hndle in better way
    if (path === config.standardPageRouteFragments.home ||
        path === "/premium" ||
        path === "/go-premium-web" ||
        path === "/" ||
        path === "/explore" ||
        path === "/explore-v4" ||
        path === "/shorts" ||
        path === "/mindblown" ||
        path === "/channel/mindblown" ||
        path === "/kids/home" ||
        path === "/go-premium-v2") {
        return renderNavbar(true);
    }
    else {
        return renderNavbar(false);
    }
});

